import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {BehaviorSubject} from 'rxjs';
import {CompanyModel} from 'src/app/models/company.model';
import {TeamModel} from 'src/app/models/team.model';
import {UserModel} from 'src/app/models/user.model';
import {AuthService} from 'src/app/services/auth/auth.service';
import {GlobalService} from 'src/app/services/global/global.service';
import {TeamService} from 'src/app/services/team/team.service';
import {UserService} from 'src/app/services/user/user.service';
import {ApiResponse} from 'src/app/services/utils';

@Component({
    selector: 'app-select-component',
    templateUrl: './select-component.component.html',
    styleUrls: ['./select-component.component.scss'],
    standalone: false
})
export class SelectComponentComponent implements OnInit {

  @Input() mySubject: BehaviorSubject<any>;

  companies: CompanyModel[];
  user: UserModel;
  postType = '0';
  teamId;
  toggleCheckoutBox = [] as any;
  userToggleCheckout = false;

  toggleCheckoutBoxFlag = [] as any;
  userToggleCheckoutFlag = false;
  team: TeamModel;

  constructor(
    private userService: UserService,
    private auth: AuthService,
    private modalCtrl: ModalController,
    private teamService: TeamService,
    private globalService: GlobalService
  ) {
  }

  ngOnInit() {
    this.user = this.auth.user;

    this.loadTeam();

    this.globalService.teamJoinedEvent.subscribe(val => {
      if (val !== null) {
        this.toggleCheckoutBox[val] = false;
        this.toggleCheckoutBoxFlag[val] = false;
      }
    });
  }

  loadTeam() {
    this.teamService.apiViewTeam(this.teamId).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.team = result?.data;
        if (this.team.isMember) {
          this.userToggleCheckout = true;
          this.userToggleCheckoutFlag = true;
        }
      }
      this.loadCompanies();
    });
  }

  loadCompanies() {
    this.userService.apiAdminCompaniesNoPagination().subscribe((result: ApiResponse) => {
      if (result.status) {
        this.companies = result.data;
        this.team.authUserCompanies.forEach(authcompany => {
          this.companies.forEach(company => {
            if (company.id === authcompany.id && (authcompany.isTeamMember === true || authcompany.isTeamAdmin === true)) {
              this.toggleCheckoutBox[company.id] = true;
              this.toggleCheckoutBoxFlag[company.id] = true;
            }
          });
        });
      }
    });
  }

  changeType(type, id) {
    let status;
    if (type === 'company') {
      this.toggleCheckoutBoxFlag[id] = !this.toggleCheckoutBoxFlag[id];
      status = this.toggleCheckoutBoxFlag[id];
    }
    if (type === 'user') {
      this.userToggleCheckoutFlag = !this.userToggleCheckoutFlag;
      status = this.userToggleCheckoutFlag;
    }
    this.mySubject.next({type, id, status});
  }

  exit() {
    this.modalCtrl.dismiss();
  }
}
